<template>
  <div class="retouchHome">
    <div class="top">
      <img src="@/assets/homeTop.png" alt="" />
      <div class="topInfo">
        <div class="topInfo-top">“ 锐信是什么 ”</div>
        <div class="topInfos" v-html="msg"></div>
        <!--区分不同组织间动画-->
        <img
          v-show="homeTops"
          :class="homeTops ? 'homeTopsAnimation' : ''"
          class="homeTops"
          src="@/assets/homeTops.png"
          alt=""
        />
      </div>
    </div>
    <div class="func">
      <div class="funcTitle">
        <div class="funcTitle-one">发一条十八般武艺的信息</div>
        <div class="funcTitle-two">Scenes to be used</div>
      </div>
      <div class="funcs funcsOne">
        <div class="funcsTitle">锐信多媒体功能</div>
        <div class="funcsInfo funcsAll">
          <div class="funcsInfoLeft">
            <div
              class="funcsInfoLeftItem"
              v-for="(item, index) in func"
              :key="index"
            >
              <div class="funcsInfoLeftop">
                {{ item.title }}
              </div>
              <div
                class="funcsInfoLefBottom funcsInfoLefBottomTwo"
                v-html="item.info"
              ></div>
              <div class="funcsInfoLabel">
                <div
                  class="funcsInfoLabels"
                  v-for="(items, indexs) in item.arr"
                  :key="indexs"
                >
                  <img src="@/assets/finish.png" alt="" srcset="" />{{ items }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="funcsInfoRight"
            ref="funcs"
            :class="showFunc ? 'showFuncs' : ''"
          >
            <img src="@/assets/funcsInfo.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="energy">
      <div
        class="energyImg"
        ref="energy"
        :class="showEnergy ? 'showFuncs' : ''"
      >
        <img src="@/assets/energy.png" alt="" srcset="" />
      </div>
      <div class="energyInfo">
        <div class="funcsTitle">小身板大优势</div>
        <div class="funcsInfoLeft energyInfos">
          <div
            class="funcsInfoLeftItem"
            v-for="(item, index) in energy"
            :key="index"
          >
            <div class="funcsInfoLeftop">
              <img src="@/assets/finish.png" alt="" srcset="" />
              {{ item.title }}
            </div>
            <div class="funcsInfoLefBottom" v-html="item.info"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="scene energy">
      <div class="sceneLeft">
        <div class="funcsTitle">多场景高效主动触达用户</div>
        <div class="sceneInfo">
          <div class="scenes" v-for="(item, index) in scene" :key="index">
            <img :src="item.img" alt="" />{{ item.txt }}
          </div>
        </div>
      </div>
      <div class="sceneImg" ref="scene" :class="showScene ? 'showFuncs' : ''">
        <img src="@/assets/scene.png" alt="" srcset="" />
      </div>
    </div>

    <div class="bright">
      <div class="funcTitle">
        <div class="funcTitle-one">锐信亮点</div>
        <div class="funcTitle-two">Use advantages</div>
      </div>
      <div class="brightInfos">
        <div
          class="brightInfosItem"
          v-for="(item, index) in bright"
          :key="index"
        >
          <img :src="item.img" alt="" srcset="" />
          <div class="brightInfosItemTxt">{{ item.txt }}</div>
        </div>
      </div>
    </div>

    <div class="bright useRx">
      <div class="funcTitle">
        <div class="funcTitle-one">他们都在使用锐信</div>
        <div class="funcTitle-two">They are all using</div>
      </div>
      <div class="useRxsInfo">
        <div class="useRxs" v-for="(item, index) in user" :key="index">
          <img :src="item.img" class="listensInfoBg" alt="" />
        </div>
      </div>
    </div>

    <div class="bright listen">
      <div class="funcTitle">
        <div class="funcTitle-one">听听他们怎么说</div>
        <div class="funcTitle-two">Listen to what they say</div>
      </div>

      <div class="brightInfo">
        <div class="listens" v-for="(item, index) in listen" :key="index">
          <div class="listensTitle funcsTitle">{{ item.txt }}</div>
          <div class="listensInfo">{{ item.info }}</div>
          <img src="@/assets/scene/listen.png" class="listensInfoBg" alt="" />
        </div>
      </div>
    </div>

    <free-trial></free-trial>

    <div class="system">
      <div class="systemLeft">
        <div class="systemLeftTop">锐信极致营销 · 互动触手可及</div>
        <div class="systemLeftInfo">
          <div class="systemLeftInfos">
            <div class="systemLeftInfo-item">公司地址</div>
            <div class="systemLeftInfo-items">
              深圳市福田区福强路3030号文化体育产业总部大厦8楼
            </div>
          </div>
          <div class="systemLeftInfos">
            <div class="systemLeftInfo-item">客服电话</div>
            <div class="systemLeftInfo-items">0755-83220948</div>
          </div>
          <div class="systemLeftInfos">
            <div class="systemLeftInfo-item">客服时间</div>
            <div class="systemLeftInfo-items">周一至周五 9:30~18:30</div>
          </div>
          <div class="systemLeftInfos">
            <div class="systemLeftInfo-item">投诉邮箱</div>
            <div class="systemLeftInfo-items">chenqianrong@youxituoluo.com</div>
          </div>
        </div>
      </div>
      <div class="systemRight">
        <img src="@/assets/navLogo.png" alt="" />
        <div class="systemRights">
          Copyright ©2020 retouchspace.com All Rigths Reserved.
        </div>
        <div class="systemRightsTwo">
          深圳市游迷天下科技有限公司 &nbsp; | &nbsp;
          <a href="http://beian.miit.gov.cn" target="_blank"
            >粤ICP备13090461号</a
          >
        </div>
        <div class="systemRightsTwo agreement-and-privacy-panel">
          <span class="agreement-and-privacy" @click="look(1)" target="_blank"
            >用户协议</span
          >
          &nbsp; | &nbsp;
          <span class="agreement-and-privacy" @click="look(2)" target="_blank"
            >隐私政策</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FreeTrial from "@/components/FreeTrial";
export default {
  name: "home",
  data() {
    return {
      scrollHeight: 0,
      msg: "“锐信”是锐量Retouch营销平台的亮点产品之一<br/>是集视频、图像、音频、场景呈现、文件传输、内容共享、即时消息推送等多种通信方式于一体的融合通信服务应用<br/>锐信极致营销 · 互动触手可及",
      homeTops: false,
      func: [
        {
          title: "一级原生态入口",
          info: "从覆盖10亿+的日活终端，一级原生态场景入口",
          arr: ["强触达性", "高打开率"],
        },
        {
          title: "精准用户 信息直达",
          info: "基于5G大数据解析直发，目标用户精准，覆盖人群广",
          arr: ["信息必读", "长效留存"],
        },
        {
          title: "展现形式丰富",
          info: "支持传送短视频+图片+二维码+链接等多媒体营<br/>销内容，打造个性化的品牌营销风格",
          arr: ["转化率高", "新鲜有趣视觉体验"],
        },
        {
          title: "内容全屏呈现",
          info: "消息一屏全覆盖展现，用户可一键完成购买、支<br/>付、投票抽奖等多类交互形式",
          arr: ["无需下载", "用户主动接收"],
        },
      ],
      energy: [
        {
          title: "超大容量",
          info: "2M内存，可发30秒超清短视频、10张高清长<br/>图、1百万字活动新闻",
        },
        {
          title: "全网匹配",
          info: "覆盖三大运营商，10秒快送，不同手机系统适配<br/>度高达96%",
        },
        {
          title: "定制签名",
          info: "企业可自由定制发送主体签名与品牌logo，满足<br/>推广需求",
        },
      ],
      scene: [
        { txt: "活动营销", img: require("@/assets/scene/scene1.png") },
        { txt: "新游上线", img: require("@/assets/scene/scene2.png") },
        { txt: "新品推荐", img: require("@/assets/scene/scene3.png") },
        { txt: "直播提醒", img: require("@/assets/scene/scene4.png") },
        { txt: "商品直购", img: require("@/assets/scene/scene5.png") },
        { txt: "积分回馈", img: require("@/assets/scene/scene6.png") },
        { txt: "新用户拉新", img: require("@/assets/scene/scene7.png") },
        { txt: "老用户召回", img: require("@/assets/scene/scene8.png") },
        { txt: "产品发布会", img: require("@/assets/scene/scene9.png") },
        { txt: "趣味短视频", img: require("@/assets/scene/scene10.png") },
        { txt: "企业视频广告", img: require("@/assets/scene/scene11.png") },
        { txt: "活动宣传视频", img: require("@/assets/scene/scene12.png") },
        { txt: "往期索引会看", img: require("@/assets/scene/scene13.png") },
        { txt: "产品订购提醒", img: require("@/assets/scene/scene14.png") },
      ],
      bright: [
        { txt: "高频阅读", img: require("@/assets/scene/bright1.png") },
        { txt: "消息强提醒", img: require("@/assets/scene/bright2.png") },
        { txt: "内容强留存", img: require("@/assets/scene/bright3.png") },
        { txt: "原生预装入口", img: require("@/assets/scene/bright4.png") },
      ],
      user: [
        { img: require("@/assets/scene/user1.png") },
        { img: require("@/assets/scene/user2.png") },
        { img: require("@/assets/scene/user3.png") },
        { img: require("@/assets/scene/user4.png") },
        { img: require("@/assets/scene/user5.png") },
      ],
      listen: [
        {
          txt: "必效CRM",
          info: "移动互联网人口红利已耗尽，企业消费端产品获客成本剧增，流量越来越贵且转化效果低下，企业的目标转向存量用户的召回和精细化运营。锐量平台富信产品的多媒体全场景即时营销消息推送极致解决我们产品用户增长和用户活跃问题，有效提升产品指标服务体系，是个不错的产品，值得推荐！",
        },
        {
          txt: "云谷文体",
          info: "锐信的商业价值，将会越来越重。国内注册企业逐渐增多，锐信会成他们推送广告的主流首选方式。它会在全国性大促活动中被频繁使用，千万不要小瞧锐信这种模式，用户会以几何级数的方式裂变增长，口碑迅速扩展，最后我们都离不开它，这就是未来。",
        },
        {
          txt: "菜花逻辑",
          info: "以后，你收到的短信将会图文并茂，包括短视频。这种颠覆性的迭代更新，会让锐信场景化服务成为爆发点。这可比普通群发短信效果来得更直接，且生动有趣。这种充满新鲜感的视觉传播法，越早使用的人更占优势。",
        },
      ],
      funcsHeight: 0, //锐信多媒体功能高度
      showFunc: false, //锐信多媒体功能图片显示
      energyHeight: 0, //小身板高度
      showEnergy: false, //小身板高度动画显示
      showScene: false, //多场景
      sceneHeight: 0, //多场景高度
    };
  },
  components: {
    FreeTrial,
  },
  created() {
    this.$nextTick(() => {
      this.homeTops = true;
      this.listenerFunction();
      this.funcsHeight = this.$refs.funcs.getBoundingClientRect().top;
      this.energyHeight = this.$refs.energy.getBoundingClientRect().top;
      this.sceneHeight = this.$refs.scene.getBoundingClientRect().top;
    });
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  methods: {
    listenerFunction(e) {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //滚动条高度
    handleScroll() {
      setTimeout(() => {
        // this.scrollHeight = window.pageYOffset

        if (!this.showFunc && window.pageYOffset > 700) {
          this.showFunc = true;
        }
        if (!this.showEnergy && window.pageYOffset > 1500) {
          this.showEnergy = true;
        }
        if (!this.showScene && window.pageYOffset > 2300) {
          this.showScene = true;
        }
      }, 100);
    },
    look(index) {
      let url = "";
      if (index == 2) {
        url =
          "https://eventimg.oss-cn-shenzhen.aliyuncs.com/common_static/terms_of_agreement/retouch_privacy_agreement.pdf";
      } else {
        url =
          "https://eventimg.oss-cn-shenzhen.aliyuncs.com/common_static/terms_of_agreement/retouch_user_service_agreement.pdf";
      }
      window.open(url);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
.retouchHome {
  .topInfo {
    padding: 58px 0 0 0;
    position: relative;
    z-index: 8;
    text-align: center;
  }
  .homeTops {
    width: 1200px !important;
    height: 665px !important;
    margin: 104px auto 0 auto !important;
    position: relative !important;
    display: block;
    opacity: 0;
    backface-visibility: hidden;
  }
  // 首页图片
  @keyframes identifier {
    from {
      transform: translateY(0px);
    }
    to {
      transform: translateY(-70px);
      opacity: 1;
    }
  }
  .homeTopsAnimation {
    animation: identifier 0.7s linear forwards;
  }
  .topInfos {
    margin-top: 35px;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: rgba(36, 46, 66, 0.6);
    line-height: 38px;
  }
  .topInfo-top {
    font-size: 50px;
    font-family: Alibaba, Alibaba-PuHuiTi;
    font-weight: PuHuiTi;
    color: #0064ff;
    line-height: 1;
    letter-spacing: 4px;
  }
  .func {
    margin-top: 223px;
    padding-top: 129px;
  }
  .top {
    position: relative;
    height: 735px;
    img {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
    }
  }
  .funcTitle {
    text-align: center;
  }
  .funcTitle-one {
    font-size: 46px;
    font-family: Alibaba, Alibaba-PuHuiTi;
    font-weight: 600;
    text-align: center;
    color: #242e42;
    line-height: 52px;
    letter-spacing: 3px;
  }
  .funcTitle-two {
    margin-top: 25px;
    font-size: 20px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: rgba(36, 46, 66, 0.6);
    line-height: 20px;
    letter-spacing: 2px;
  }
  .funcs {
    margin-top: 144px;
    padding: 0 360px;
  }
  .funcsOne {
    padding: 0 339px 0 360px;
  }
  .funcsTitle {
    font-size: 32px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    color: #242e42;
    line-height: 32px;
  }
  .funcsInfo {
    display: flex;
    margin-top: 42px;
  }
  .funcsAll {
    margin-top: 0;
  }
  .funcsInfoLeftItem {
    margin-top: 40px;
  }
  .funcsInfoLeftop {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #242e42;
    line-height: 1;
    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  .funcsInfoLabel {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .funcsInfoLabels {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #0064ff;
    line-height: 1;
    margin-right: 32px;
    img {
      width: 18px;
      height: 18px;
      margin-right: 9px;
    }
  }
  .funcsInfoLefBottomTwo {
    margin-top: 8px !important;
  }
  .funcsInfoLefBottom {
    margin-top: 14px;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: justify;
    color: rgba(36, 46, 66, 0.6);
    line-height: 32px;
    text-align: justify;
  }
  .funcsInfoRight {
    margin-left: 71px;
    margin-top: 197px;
    width: 765px;
    height: 443px;
    opacity: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  // 锐信多媒体功能
  @keyframes showFuncsA {
    from {
      transform: translateY(0px);
    }
    to {
      transform: translateY(-70px);
      opacity: 1;
    }
  }

  .showFuncs {
    animation: showFuncsA 0.7s linear forwards;
  }
  .energy {
    padding: 0 360px;
    margin-top: 150px;
    display: flex;
  }
  .energyInfo {
    margin: 22px 0 0 108px !important;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
  }
  .energyInfos {
    height: auto;
  }

  .energyImg {
    width: 701px;
    height: 491px;
    opacity: 0;
    position: relative;
    img {
      position: absolute;
      top: 70px;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .sceneInfo {
    display: flex;
    width: 590px;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 22px;
  }
  .scenes {
    margin-top: 20px;
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 1;
    width: 280px;
    height: 64px;
    background: #ffffff;
    border: 1px solid #d7e7ff;
    border-radius: 4px;
    box-shadow: 4px 4px 8px 0px rgba(203, 219, 243, 0.16);
    padding-left: 25px;
    img {
      width: 30px;
      height: 30px;
      margin-right: 5px;
    }
  }
  .sceneImg {
    width: 525px;
    height: 579px;
    margin-top: 133px;
    margin-left: 94px;
    opacity: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .bright {
    margin-top: 169px;
    padding: 0 360px;
  }
  .listen {
    padding-bottom: 124px;
  }
  .brightInfo {
    margin-top: 120px;
    display: flex;
    justify-content: space-between;
  }
  .listens {
    width: 380px;
    height: 440px;
    background: #ffffff;
    border: 1px solid #f4f6f9;
    border-radius: 18px;
    box-shadow: 0px 11px 12px 3px rgba(203, 219, 243, 0.16);
    padding: 50px 0px 46px 0px;
    position: relative;
  }
  .listensInfo {
    margin-top: 24px;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: justify;
    color: rgba(36, 46, 66, 0.8);
    line-height: 32px;
    position: relative;
    z-index: 8;
    padding: 0px 40px;
  }
  .listensTitle {
    padding: 0px 40px;
  }
  .listensInfoBg {
    position: absolute;
    z-index: 1;
    width: 121px;
    height: 128px;
    left: 0;
    bottom: 0px;
  }
  .useRxsInfo {
    display: flex;
    justify-content: space-between;
    margin-top: 120px;
  }
  .useRxs {
    width: 224px;
    height: 70px;
    border: 1px solid #d7e7ff;
    border-radius: 4px;
    cursor: pointer;
    img {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
  .useRxs:hover {
    border: 1px solid rgba(0, 100, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(97, 131, 155, 0.2);
  }
  .brightInfos {
    margin-top: 90px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .brightInfosItem {
    width: 585px;
    height: 228px;
    background: #f7f9fc;
    display: flex;
    align-items: center;
    border-radius: 19px;
    margin-top: 30px;
    cursor: pointer;
    img {
      width: 215px;
      height: 100%;
      margin-right: 13px;
    }
  }
  .brightInfosItemTxt {
    font-size: 28px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    color: #242e42;
    line-height: 28px;
  }
  .system {
    padding: 82px 360px;
    display: flex;
    justify-content: space-between;
  }
  .systemRight {
    text-align: right;
    img {
      width: 174px;
      height: 28px;
    }
  }
  .systemLeftTop {
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #242e42;
    line-height: 1;
  }
  .systemLeftInfo {
    padding-top: 30px;
  }
  .systemLeftInfos {
    display: flex;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: rgba(36, 46, 66, 0.6);
    line-height: 18px;
    margin-top: 30px;
  }
  .systemLeftInfo-items {
    margin-left: 46px;
  }
  .systemRights {
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: right;
    color: rgba(36, 46, 66, 0.6);
    line-height: 18px;
    margin-top: 94px;
  }
  .systemRightsTwo {
    text-align: right;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: right;
    color: rgba(36, 46, 66, 0.8);
    line-height: 18px;
    margin-top: 32px;
    a {
      color: rgba(36, 46, 66, 0.8);
    }
  }
  .agreement-and-privacy {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home.vue